import Vue from 'vue'
import Vuex from 'vuex'

import 'es6-promise/auto'

import ComuniDataService from '@/service/ComuniDataService.js'
import ServiziDataService from '@/service/ServiziDataService.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    status: '',
    codiceTheme: sessionStorage.getItem('comune') ? sessionStorage.getItem('comune') : 'favicon',
    comune: {},
    servizio: {},
    backOffice: ''
  },
  mutations: {
    theme (state, currentComuneTheme) {
      state.status = 'theme settato'
      state.codiceTheme = currentComuneTheme
    },
    set_comune (state, comune, codice) {
      state.status = 'setted comune'
      state.comune = comune
      state.codiceTheme = codice
    },
    set_open_comune (state, comune) {
      state.status = 'area backoffice on'
      state.comune = comune
      state.backOffice = 'Archivio'
    },
    set_servizio (state, servizio) {
      state.status = 'setted servizio'
      state.servizio = servizio
    },
    switch (state, value) {
      state.backOffice = value
    },
    clear_store (state) {
      state.status = 'no logged comune'
      state.codiceTheme = 'favicon'
      state.comune = {}
      state.servizio = {}
      state.backOffice = ''
    }

  },
  actions: {
    setComune ({ commit }, newValue) {
      console.log('setComune with', newValue)
      ComuniDataService
        .getComuneById(newValue)
        .then(response => {
          const comune = response.data
          const codice = response.data.codiceCatasto
          sessionStorage.setItem('comune', codice)
          console.log(comune)
          commit('set_comune', comune, codice)
        })
        .catch(e => {
          console.log(e)
          commit('clear_store')
        })
    },
    caricaInfoServizio ({ commit }, id) {
      ServiziDataService
        .getServizioById(id)
        .then(response => {
          const servizio = response.data
          console.log(servizio)
          commit('set_servizio', servizio)
        })
        .catch(e => {
          console.log(e)
          commit('clear_store')
        })
    },
    logAsAdmin ({ commit }, newValue) {
      return new Promise((resolve, reject) => {
        console.log('setComune as', newValue)
        commit('set_open_comune', newValue)
        resolve()
      })
    },
    clearStore ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('clear_store')
        resolve()
      })
    },
    swithArchivio ({ commit }, value) {
      return new Promise((resolve, reject) => {
        var newvalue = null
        if (value === 'Archivio') {
          newvalue = 'Principale'
        } else {
          newvalue = 'Archivio'
        }
        commit('switch', newvalue)
        resolve(newvalue)
      })
    },
    setTheme ({ commit, state }, idcomune) {
      var currentTheme = state.codiceTheme

      // set theme
      if (currentTheme !== idcomune) {
        sessionStorage.setItem('comune', idcomune)
        currentTheme = sessionStorage.getItem('comune')
      }
      document.body.setAttribute('data-theme', currentTheme)
      // set favicon
      var OldLink = document.querySelector("link[rel~='icon']")
      var link = document.createElement('link')
      link.rel = 'icon'
      if (currentTheme === '') {
        currentTheme = state.codiceTheme
      }
      link.href = process.env.BASE_URL + currentTheme + '.png'
      if (OldLink) {
        document.head.removeChild(OldLink)
        console.log('rimosso', OldLink)
      }
      document.head.appendChild(link)
      var nuevolink = document.querySelector("link[rel~='icon']")
      console.log('caricato', nuevolink)

      console.log('caricato il nuovo tema')
      commit('theme', currentTheme)
    }
  },
  getters: {
    getComune: state => state.comune,
    getServizio: state => state.servizio,
    backoffice: state => state.backOffice
  }
})
export default store
